import React, { useState, Component } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search } from 'lucide-react';
import { Button } from './ui/Button';
interface SearchBarProps {
  variant?: 'hero' | 'compact';
  initialValue?: string;
  className?: string;
}
export function SearchBar({
  variant = 'hero',
  initialValue = '',
  className = ''
}: SearchBarProps) {
  const [query, setQuery] = useState(initialValue);
  const navigate = useNavigate();
  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (query.trim()) {
      navigate(`/search?q=${encodeURIComponent(query)}`);
    }
  };
  if (variant === 'hero') {
    return <form onSubmit={handleSearch} className={`w-full max-w-3xl relative group ${className}`} data-id="element-158">
        {/* Glow effect behind */}
        <div className="absolute -inset-1 bg-gradient-to-r from-transparent via-[#D22B2B]/20 to-transparent blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-700" data-id="element-159"></div>

        <div className="relative flex items-center" data-id="element-160">
          <input type="text" value={query} onChange={e => setQuery(e.target.value)} placeholder="Название, актёр, режиссёр, сценарист…" className="w-full h-16 pl-8 pr-36 bg-[#0a0a0a]/80 backdrop-blur-sm border border-[#333] text-lg md:text-xl text-white placeholder:text-gray-600 focus:outline-none focus:border-[#D22B2B] focus:ring-1 focus:ring-[#D22B2B]/30 transition-all shadow-2xl font-serif tracking-wide" data-id="element-161" />
          <div className="absolute right-2 top-2 bottom-2" data-id="element-162">
            <Button type="submit" size="md" className="h-full shadow-none border-0 bg-[#D22B2B] hover:bg-[#b01e1e] text-white" data-id="element-163">
              Найти
            </Button>
          </div>
        </div>
      </form>;
  }
  return <form onSubmit={handleSearch} className={`w-full ${className}`} data-id="element-164">
      <div className="relative flex items-center" data-id="element-165">
        <Search className="absolute left-3 h-4 w-4 text-gray-600" data-id="element-166" />
        <input type="text" value={query} onChange={e => setQuery(e.target.value)} placeholder="Поиск по каталогу..." className="w-full h-10 pl-9 pr-4 bg-[#0a0a0a] border border-[#333] text-sm text-gray-300 focus:outline-none focus:border-[#D22B2B] transition-colors" data-id="element-167" />
      </div>
    </form>;
}